import clientConfigurationProvider from "../../../providers/clientConfigurationProvider";

export default ({ pathname }) => {
  const { siteRootPath } = clientConfigurationProvider();

  return pathname.substr(siteRootPath.length).split("/").filter(Boolean);
};
